/** @format */

import { useEffect, useState } from "react";

import { LOADING_MESSAGES } from "./constants";
import LoadingCircle from "./LoadingCircle";

// Loading fallback component for lazy-loaded routes
const PageLoader = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(() =>
    Math.floor(Math.random() * LOADING_MESSAGES.length)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex(Math.floor(Math.random() * LOADING_MESSAGES.length));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const loadingMessage = LOADING_MESSAGES[currentMessageIndex];

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex flex-col justify-center items-center">
        <LoadingCircle className="h-auto w-full max-h-[100px]" />
        <h2 className="text-center text-2xl capitalize">{loadingMessage}</h2>
      </div>
    </div>
  );
};

export default PageLoader;
